import Text from "../../../../framework/component/form/input-types/Text";
import RegistrationModel from "../model/RegistrationModel";
import {useFieldArray, useFormContext} from "react-hook-form";
import PhoneNumber from "../../../../framework/component/form/input-types/PhoneNumber";
import Row from "react-bootstrap/Row";
import {Button, Form} from "react-bootstrap";
import Col from "react-bootstrap/Col";

/**
 * This component represents the contact information section for the registration screen
 */
export default function ContactInformation() {
  const {control, formState: {errors}, getValues} = useFormContext<RegistrationModel>();
  const {fields, append, remove} = useFieldArray({
    control,
    name: "contactInfo.extraPhoneNumbers"
  });

  /**
   * This function is used to validate a phone number format.
   * @param v The value that will be validated
   */
  const validateInputIsNumeric = (v: string): true | string => {
    if (!v || v.trim().length === 0) {
      return "Phone number is required";
    }

    const regex = /^[0-9 ]+$/;
    return regex.test(v)
      ? true
      : "Your phone number must contain only numbers";
  }

  return <>
    {/*Email*/}
    <Text<RegistrationModel>
      label={"Contact Email"}
      error={errors.contactInfo?.contactEmail}
      fieldId={"contactInfo.contactEmail"}
      disabled={getValues("institutes.primaryInstitute.instituteName") === undefined}/>
    {/*Phone 1*/}
    <PhoneNumber<RegistrationModel>
      label={"Phone Number"}
      errors={errors}
      fieldId={"contactInfo.phoneNumber1"}
      mandatory
      validateNumber={validateInputIsNumeric}/>
    {/*Phones 2 and 3*/}
    <Form.Group as={Row}>
      <Form.Label column sm={2}>
      </Form.Label>
      <Col sm={10}>
        <p className={"question-help-text"}>You may add up to 2 alternative phone numbers</p>
      </Col>
    </Form.Group>
    {fields.map((field, index) => (
      <PhoneNumber<RegistrationModel>
        label={""}
        errors={errors}
        fieldId={`contactInfo.extraPhoneNumbers.${index}`}
        deletePhoneTrigger={() => remove(index)}
        validateNumber={validateInputIsNumeric}/>
    ))}
    <Form.Group as={Row} className="mb-2">
      <Form.Label column sm={2}>
      </Form.Label>
      <Col sm={8}>
        {fields.length < 2 &&
            <Button variant="primary" onClick={() => append({countryCode: "+44", number: ""})}>
              <i className="bi bi-plus-circle"/> Add phone
            </Button>}
      </Col>
    </Form.Group>
  </>
}